import { render } from "./Entregar.vue?vue&type=template&id=0672421a"
import script from "./Entregar.vue?vue&type=script&lang=js"
export * from "./Entregar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__